var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoicedownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 45,
    viewBox: "0 0 110 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.67871,
    y: 5.5,
    width: 94.6426,
    height: 34,
    rx: 5,
    fill: "#0E487A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5899 28H42.4279V18.662H43.5899V28ZM53.5055 28H52.3855L46.9395 20.552V28H45.7775V18.662H46.9675L52.3435 25.956V18.662H53.5055V28ZM59.9177 28H58.4757L54.7237 18.662H56.0537L59.2037 26.726L62.3537 18.662H63.6837L59.9177 28ZM68.8871 28.168C66.1151 28.168 64.2531 26.096 64.2531 23.338C64.2531 20.58 66.1151 18.508 68.8871 18.508C71.6451 18.508 73.5211 20.58 73.5211 23.338C73.5211 26.096 71.6451 28.168 68.8871 28.168ZM68.8871 27.132C70.9731 27.132 72.3171 25.508 72.3171 23.338C72.3171 21.154 70.9731 19.544 68.8871 19.544C66.7871 19.544 65.4571 21.154 65.4571 23.338C65.4571 25.508 66.7871 27.132 68.8871 27.132ZM76.4981 28H75.3361V18.662H76.4981V28ZM83.1098 28.168C80.4218 28.168 78.3078 26.208 78.3078 23.338C78.3078 20.468 80.4218 18.508 83.1098 18.508C84.7618 18.508 85.9098 19.306 86.6518 20.356L85.6718 20.902C85.1398 20.118 84.1738 19.544 83.1098 19.544C81.0658 19.544 79.5118 21.112 79.5118 23.338C79.5118 25.55 81.0658 27.132 83.1098 27.132C84.1738 27.132 85.1398 26.572 85.6718 25.774L86.6658 26.32C85.8818 27.384 84.7618 28.168 83.1098 28.168ZM94.2647 28H88.1467V18.662H94.2647V19.698H89.3087V22.708H94.1667V23.744H89.3087V26.964H94.2647V28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1943 21.5V27.5L25.1943 25.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1943 27.5L21.1943 25.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1943 20.5V25.5C36.1943 30.5 34.1943 32.5 29.1943 32.5H23.1943C18.1943 32.5 16.1943 30.5 16.1943 25.5V19.5C16.1943 14.5 18.1943 12.5 23.1943 12.5H28.1943",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1943 20.5H32.1943C29.1943 20.5 28.1943 19.5 28.1943 16.5V12.5L36.1943 20.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicedownload);
export default __webpack_public_path__ + "static/media/Invoice download.9dd77dd9a1ee59546ff065712c1ef6ad.svg";
export { ForwardRef as ReactComponent };